import { ChallengeFormType, FormValidator } from '../../NewChallengeForm.types';

export const validate: FormValidator<Pick<ChallengeFormType, 'category'>> = ({
  category,
}) => {
  if (!category) return { isValid: false, message: '카테고리를 확인해주세요' };
  return { isValid: true };
};
